<ng-container *ngIf="survey$ | async let data">
  <div
    [ngClass]="{ 'widget-content': expanded }"
    [@expand]="expanded ? 'expanded' : 'collapsed'"
  >
    <ng-container *ngIf="expanded">
      <!-- Tracker Widget-->
      <ng-container
        *ngIf="widget?.key === widgets.groupedSurveys && widgetInfo.type === 'tracker'"
      >
        <div>
          <ps-ui-manage-tracker
            [mcUniqueId]="survey.mc_unique_id!"
            [userType]="userType"
          ></ps-ui-manage-tracker>
        </div>
      </ng-container>

      <!-- Traffic Channels Widget -->
      <ng-container *ngIf="widget?.key === widgets.traffic">
        <ps-ui-manage-traffic-channels
          [survey]="data"
          [canAddTrafficChannels]="false"
          [isDashboard]="isDasaboard"
          [dashbordTabStatus]="dashbordTabStatus"
          [isMultiCountryWidget]="isMultiCountryWidget"
        ></ps-ui-manage-traffic-channels>
      </ng-container>

      <!-- Multi Country Widget-->
      <ng-container
        *ngIf="widget?.key === widgets.groupedSurveys && widgetInfo.type === 'mc'"
      >
        <div>
          <ps-ui-manage-multi-country
            [surveyId]="survey.surveyId"
            [mcUniqueId]="data.mc_unique_id"
          ></ps-ui-manage-multi-country>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
